import axios from "axios";

import {
	FETCH_ORDER,
	//FETCH_ORDER_DATE,
	SHOW_DETAILS,
	UPDATE_ORDER_STATUS,
	DELETE_ORDER,
	UPDATE_ORDER__DELIVERY_STATUS,
} from "constants/ActionTypes";

const AUTH_TOKEN =
	"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJoZWFkZXIiOnsiaWQiOiIwIiwidXNlciI6Ik1hbnVlbEdpbCJ9LCJwYXlsb2FkIjp7ImlhdCI6IjIwMTktMDEtMDEgMDA6MDA6MDAiLCJleHAiOiIyMDIwLTAxLTAxIDAwOjAwOjAwIn19.p_PtmXsDe3l_osPEzb4edkf-M2SCdUVBQBKs8ZAbpn8";
const ROOT_URL = "https://admingreenerapp.crsostenible.com/api/public/api/app/";

export function fetchOrders(
	{ dateFrom, dateTo },
	callback = () => {
		console.log();
	}
) {
	const config = {
		headers: {
			Authorization: "Bearer " + AUTH_TOKEN,
		},
	};

	const ROUTINES = `order/history/get/${dateFrom.replace(
		/\//g,
		"-"
	)}/${dateTo.replace(/\//g, "-")}`;
	const url = `${ROOT_URL}${ROUTINES}`;
	const request = axios
		.get(url, config)
		.then((request) => {
			//if (request.data.success == 1) {
			return request.data.data;
			/* } else {
        return []
      }*/
		})
		.then(callback());
	return {
		type: FETCH_ORDER,
		payload: request,
	};
}

export function updateStatusOrder(
	{ id, hour, date, status },
	callback = () => console.log()
) {
	console.log(status);
	const ROUTINES = "order/update_status";
	const url = `${ROOT_URL}${ROUTINES}`;
	const request = axios({
		method: "post",
		url: `${ROOT_URL}${ROUTINES}`,
		data: {
			order_id: id,
			hour: hour,
			date: date,
			delivery_status: status,
		},
		headers: {
			"Content-Type": "application/json",
			Authorization: "Bearer " + AUTH_TOKEN,
		},
	})
		.then((request) => request.success)
		.then(callback());
	return {
		type: UPDATE_ORDER_STATUS,
		payload: request,
	};
}
/***********/
/*
export function fetchOrderDate(
  {dateFrom, dateTo},
  callback = () => {
    console.log()
  },
) {

  const config = {
    headers: {
    
    'Authorization': 'Bearer ' + AUTH_TOKEN
  },
  }

  const ROUTINES = `order/history/get/${dateFrom}/${dateTo}`
  const url = `${ROOT_URL}${ROUTINES}`
  const request = axios
    .get(url,config)
    .then(request => {
      //if (request.data.success == 1) {
        return request.data.data
     /* } else {
        return []
      }*/
/*})
    .then(callback())
  return {
    type: FETCH_ORDER_DATE,
    payload: request,
  }
}
*/

/************/

export function showdetails() {
	const ROUTINES = `history/order/detail/${7}`;
	const request = axios({
		method: "get",
		url: `${ROOT_URL}${ROUTINES}`,
		headers: {
			"Content-Type": "application/json",
			Authorization: "Bearer " + AUTH_TOKEN,
		},
	})
		.then((request) => console.log(request.data.data))
		.catch((error) => error);
	return {
		type: SHOW_DETAILS,
		payload: request,
	};
}

export function deleteOrder(id, callback = () => console.log()) {
	const ROUTINES = "order/canceled";
	const request = axios({
		method: "post",
		url: `${ROOT_URL}${ROUTINES}`,
		data: {
			order_id: id,
			status: 0,
		},
		headers: {
			"Content-Type": "application/json",
			Authorization: "Bearer " + AUTH_TOKEN,
		},
	})
		.then((request) => request.success)
		.then(callback());
	return {
		type: DELETE_ORDER,
		payload: request,
	};
}

export function updateDeliveryStatus(
	order_id,
	delivery_status,
	callback = () => console.log()
) {
	console.log(delivery_status);
	const ROUTINES = "order/update_delivery_status";
	const request = axios({
		method: "post",
		url: `${ROOT_URL}${ROUTINES}`,
		data: {
			order_id: order_id,
			delivery_status: delivery_status,
		},
		headers: {
			"Content-Type": "application/json",
			Authorization: "Bearer " + AUTH_TOKEN,
		},
	})
		.then((request) => request.success)
		.then(callback());
	return {
		type: UPDATE_ORDER__DELIVERY_STATUS,
		payload: request,
	};
}



// WEBPACK FOOTER //
// ./src/appRedux/actions/Orders.js